// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b597ad5","667":"b8b2f154"}[chunkId] + ".chunk.js";
};